module.exports = __webpack_public_path__ + "static/media/minus.1647e2e4.svg";